const serviceUrl = `${__configuration.apiUrl}/massia/avoir`;

export default class AvoirsService {
	static $inject = ['$http', 'notification', '$translate', 'localStorageService', 'AuthConstant'];

	constructor($http, notification, $translate, localStorageService, AuthConstant) {
		this.$http = $http;
		this.notification = notification;
		this.$translate = $translate;
		this.localStorageService = localStorageService;
		this.AuthConstant = AuthConstant;
	}

	async getAvoir(idFactures, isAvoirTotal) {
		let res = await this.$http.get(serviceUrl, {
			params: {
				idFactures: JSON.stringify(idFactures || []),
				isAvoirTotal: isAvoirTotal
			}
		});
		return res.data;
	}

	async verifFacture(data) { 
		const result = await this.$http.post(serviceUrl + "/verif", data);
		console.log(data);
		return result.data;
	}

	async createAvoir(data) {
		const result = await this.$http.post(serviceUrl, data);
		return result.data;
	}

	async getValorisation(data) {
		let url = `${serviceUrl}/valorisation`;
		const result = await this.$http.post(url, data);
		return result.data;
	}

	async deleteTicketFictifs(idTickets) {
		return this.$http.delete(serviceUrl, {
			params: {
				idTickets: JSON.stringify(idTickets || []),
			}
		});
	}

	async resetTicket(data) {
		const result = await this.$http.put(serviceUrl, data);
		return result.data;
	}
}